import { createReducer } from '@reduxjs/toolkit'

import { logoutAC } from 'model/system/systemActionCreators';
import { typePagination } from 'model/system/constants';
import {
    dTransferCashDesksClearFiltersAC,
    dTransferCashDesksSetDataAC,
    dTransferCashDesksSetDetailItemAC,
    dTransferCashDesksSetFiltersAC, dTransferCashDesksSetItemsForPageAC,
    dTransferCashDesksSetPageNumberAC,
    dTransferCashDesksSetPaginationAC
} from 'model/dashboardTransferCashDesks/dTransferCashDesksActionCreators';



// Type
export type typeStatusPosTransfer = 'выдан' | 'возвращен'

export type IdTransferCashDesksStateDataItem= {
    id: string,
   posSnNumber: string,
   status: string,
   to: {
        id: string,
       name: string
   }
   date: string
    whoDidIt: {
        id:string,
        name: string,
        position?: string
    }
}

export type typeTransferCashDesksFilters = {
   status?: string | null,
    date?: {
        from: string | null,
        to: string | null,
    } | null,
posSnNumber?: string | null
}




export type IdTransferCashDesksState = {
    data: IdTransferCashDesksStateDataItem[],
    detailItem: IdTransferCashDesksStateDataItem | undefined,
    filters: typeTransferCashDesksFilters,
    pagination: typePagination,

}


// Clean filter object
export const cleanFilterObject: typeTransferCashDesksFilters = {
posSnNumber: null,
    status: null,
    date: null
}

// Init state
export const initialState: IdTransferCashDesksState = {
    data: [],
    detailItem: undefined,
    filters: cleanFilterObject,
    pagination: {
        pageNumber: 0,
        itemsPerPage: 14,
    },

}


// Reducer
export const DTransferCashDesksReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set data
        .addCase(dTransferCashDesksSetDataAC, (state, action) => {
            state.data = action.payload.dataList
        })
        // Reducer of set pagination
        .addCase(dTransferCashDesksSetPaginationAC, (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload.pagination }
        })
        // Reducer of set items for page pagination
        .addCase(dTransferCashDesksSetItemsForPageAC, (state, action) => {
            state.pagination = { ...state.pagination,pageNumber:0, itemsPerPage: action.payload.itemsForPage }
        })
        // Reducer of set pageNumber pagination
        .addCase(dTransferCashDesksSetPageNumberAC, (state, action) => {
            state.pagination.pageNumber = action.payload.pageNumber
        })

        // Reducer of set detail item
        .addCase(dTransferCashDesksSetDetailItemAC, (state, action) => {
            state.detailItem = state.data.find((item) => item.id === action.payload)
        })




        // Reducer of clear filtersForm
        .addCase(dTransferCashDesksClearFiltersAC, (state) => {
            state.filters = cleanFilterObject
        })

        // Reducer of set filtersForm
        .addCase(dTransferCashDesksSetFiltersAC, (state, action) => {
            state.filters = {...state.filters, ...action.payload}
        })



        // Reducer of clear state
        .addCase(logoutAC, (state) => {
            state.data = initialState.data
            state.detailItem = initialState.detailItem
            state.filters = initialState.filters

        })

})
